import React, {  Dispatch, SetStateAction, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FiCheck, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { useClickOutside } from "../../../../components/hook/clickOutside";
import { FilterItem, FilterValue, formatFilterLabel, getCuisineDisplayLabel } from "../../../../components/types/types";
import { NOTE_MAX, NOTE_MIN, NOTE_STEP, useNoteFilter } from "../../../../utils/utilsNotes";
import { PRICE_MAX, PRICE_MIN, PRICE_STEP, usePriceSlider } from "../../../../utils/utilsPrice";
import { useSwipeDownToClose } from "../hookSearchPage";
import './hookFilterSearch.css'


const getTypeGroup = (value: FilterValue) => {
    if (typeof value !== "string") return "concept";
    if (value.startsWith("dish:") ||value.startsWith("regime:") ||value.startsWith("concept-unique:")) return "concept_unique";
    if ( value.startsWith("country:") ||value.startsWith("french-region:") ||value.startsWith("cultural-region:")) return "country";
    return "concept";
};
const isSameFilter = (a: FilterValue, b: FilterValue) => {
    if (Array.isArray(a) && Array.isArray(b)) {
        return a[0] === b[0] && a[1] === b[1];
    }

    return a === b;
};
const isInList = (list: FilterValue[], value: FilterValue) => {
    return list.some(elem => isSameFilter(elem, value));
};


interface ExpandedFilterProps {
    filter: FilterItem;
    listFilter: FilterValue[];
    lockedFilterValues: Set<string>;
    applyFilterGroup: (
        groupValues: FilterValue[],
        selectedValues: FilterValue[]
    ) => void;
    setShowCantFilter: Dispatch<SetStateAction<boolean>>;
    onClose: () => void;
}

export const ExpandedFilter:React.FC<ExpandedFilterProps> = ({ filter,listFilter,lockedFilterValues,applyFilterGroup,setShowCantFilter,onClose}) => {
    const refContainer = useRef<HTMLDivElement | null>(null);
    const isTypeRestaurant = filter.value === "Type de restaurant";
    const isOrigineCuisine = filter.value === "Origine de la cuisine";

    const orderedFilterList = useMemo(() => {
        return filter.liste ?? [];
    }, [filter.liste]);
    const groupedTypes = useMemo(() => {
        const groups = {
            country: [] as FilterValue[],
            concept: [] as FilterValue[],
            concept_unique: [] as FilterValue[],
        };
        orderedFilterList.forEach(elem => {
            groups[getTypeGroup(elem)].push(elem);
        });
        return groups;
    }, [orderedFilterList]);
    const [tempSelect, setTempSelect] = useState<FilterValue[]>(() => {
        return (filter.liste ?? []).filter(elem =>
            isInList(listFilter, elem)
        );
    });
    const [openTypeGroups, setOpenTypeGroups] = useState({concept: true,country: true,concept_unique: true,});
    const [showAllConcept, setShowAllConcept] = useState(false);
    useEffect(() => {
        setTempSelect(
            (filter.liste ?? []).filter(elem =>
                isInList(listFilter, elem)
            )
        );
    }, [filter, listFilter]);

    const closeExpanded = useCallback(() => {
        setShowCantFilter(false);
        onClose();
    }, [onClose, setShowCantFilter]);
    const { dragHandlers } = useSwipeDownToClose({containerRef: refContainer,onClose: closeExpanded,});
    useClickOutside(refContainer,true,closeExpanded);
    const toggleTempSelect = (value: FilterValue) => {
        setTempSelect(prev => {
            const alreadySelected = isInList(prev, value);
            if (alreadySelected) return prev.filter(elem => !isSameFilter(elem, value));
            return [...prev, value];
        });
    };
    const clearCurrentFilter = () => {
        setTempSelect([]);
    };
    const applyFilter = () => {
        if (!filter.liste) return;

        setShowCantFilter(false);
        applyFilterGroup(filter.liste, tempSelect);
        onClose();
    };
    const toggleTypeGroup = (group: "concept" | "country" | "concept_unique" ) => {
        setOpenTypeGroups(prev => ({
            ...prev,
            [group]: !prev[group],
        }));
    };


    return <>
    <div className="maskContainerShowAllFilter maskShowMore"></div>
    <div className={`containerShowAllFilter smallText primaryBack ${(filter.value === 'Type de restaurant' || filter.value === 'Origine de la cuisine') ? 'isLarge' : ''}`} ref={refContainer}>
        <div className="topPart" {...dragHandlers}>
            <span className="midTextBold">{filter.value}</span>
            <FiChevronUp className="close pointer" size={23} onClick={e => { e.stopPropagation(); closeExpanded();}}/>
            
            <div className="shadowTop"></div>
          </div>
          <div className="separationTop"><div className="shadowTop"></div></div>
          <div className="contentPart">
            {isTypeRestaurant ? (
                <>
                    {groupedTypes.concept.length > 0 && (
                            <>
                            <div className="smallTextBold filterTypeGroupTitle" onClick={() => toggleTypeGroup("concept")}>Concept {!openTypeGroups.concept ? <FiChevronDown className="icon" size={18} /> :  <FiChevronUp className="icon" size={18} />}   </div>
                                {openTypeGroups.concept && (groupedTypes.concept.length >= 8 && !showAllConcept ? groupedTypes.concept.slice(0, 6) : groupedTypes.concept).map((elem, index) => {
                                    const isLocked = typeof elem === "string" && lockedFilterValues.has(elem);
                                    return <div key={"elemSearchConcept" + index} onClick={() => {if(!isLocked){toggleTempSelect(elem)}else{setShowCantFilter(true)}}} className={`elem ${isInList(tempSelect, elem) ? "isSelect" : ""} ${isLocked ? 'isLocked' : ''}`}>
                                        {formatFilterLabel(elem)}
                                    </div>
                                })}
                                {openTypeGroups.concept && groupedTypes.concept.length >= 8 && (
                                    <div className="wrapperSeeMoreConcept"><div className="seeMoreConcept XsmallText" onClick={() => setShowAllConcept(prev => !prev)}>
                                        {showAllConcept ? "Afficher moins" : "Afficher plus"}
                                    </div>
                                    </div>
                                )}
                            </>
                    )}
                    {(groupedTypes.concept.length > 0 && (groupedTypes.country.length > 0 || groupedTypes.concept_unique.length > 0)) && <div className="sepfilterTypeGroup"></div>}
                    {groupedTypes.country.length > 0 && (
                        <>
                            <div className="smallTextBold filterTypeGroupTitle" onClick={() => toggleTypeGroup("country")}>Pays et régions {!openTypeGroups.country ? <FiChevronDown className="icon" size={18} /> :  <FiChevronUp className="icon" size={18} />}</div>
                            {openTypeGroups.country && groupedTypes.country.map((elem, index) => {
                                const isLocked = typeof elem === "string" && lockedFilterValues.has(elem);
                                return <div key={"elemSearchCountry" + index} onClick={() => {if(!isLocked){toggleTempSelect(elem)}else{setShowCantFilter(true)}}} className={`elem ${isInList(tempSelect, elem) ? "isSelect" : ""} ${isLocked ? 'isLocked' : ''}`}>
                                    {formatFilterLabel(elem)}
                                </div>
                            })}
                        </>
                    )}
                    {groupedTypes.country.length > 0 && groupedTypes.concept_unique.length > 0 && <div className="sepfilterTypeGroup"></div>}
                    {groupedTypes.concept_unique.length > 0 && (
                        <>
                            <div className="smallTextBold filterTypeGroupTitle" style={{marginTop:0}} onClick={() => toggleTypeGroup("concept_unique")}>Concept unique / rare {!openTypeGroups.concept_unique ? <FiChevronDown className="icon" size={18} /> :  <FiChevronUp className="icon" size={18} />}</div>
                            {openTypeGroups.concept_unique && groupedTypes.concept_unique.map((elem, index) => {
                                const isLocked = typeof elem === "string" && lockedFilterValues.has(elem);
                                return <div key={"elemSearchUnique" + index} onClick={() => {if(!isLocked){toggleTempSelect(elem)}else{setShowCantFilter(true)}}} className={`elem ${isInList(tempSelect, elem) ? "isSelect" : ""} ${isLocked ? 'isLocked' : ''}`}>
                                    {formatFilterLabel(elem)}
                                </div>
                            })}
                        </>
                    )}
                </>
            ) : (
                (isOrigineCuisine
                    ? [...(filter.liste ?? [])].sort((a, b) =>
                        getCuisineDisplayLabel(formatFilterLabel(a)).localeCompare(getCuisineDisplayLabel(formatFilterLabel(b)),"fr",{ sensitivity: "base" })
                    )
                    : filter.liste ?? []
                ).map((elem, index) => {
                    const isLocked = typeof elem === "string" && lockedFilterValues.has(elem);
                    return <div key={"elemSearch" + index} onClick={() => {if(!isLocked){toggleTempSelect(elem)}else{setShowCantFilter(true)}}} className={`elem ${isInList(tempSelect, elem) ? "isSelect" : ""} ${isLocked ? 'isLocked' : ''}`}>
                        {isOrigineCuisine ? getCuisineDisplayLabel(formatFilterLabel(elem)) : formatFilterLabel(elem)}
                    </div>
                })
            )}
          </div>
          <div className="bottomPart">
            <div className="cleanButton smallWhiteRoundButton" onClick={clearCurrentFilter}>Tout effacer</div>
            <div className='midGoldRoundButton'  onClick={applyFilter}>Appliquer</div>
          </div>
    </div>
    </>
}


interface HookFilterProps {
    searchValue:string,
    filter:FilterItem,
    listFilter:(string  |[number,number])[],
    addFilter:(filter:(string  |[number,number])) => void,
    applyFilterGroup:(groupValues: FilterValue[],selectedValues: FilterValue[]) => void,
    lockedFilterValues: Set<string>;
    filterResultCounts?: Map<string, number>;
    setShowCantFilter:Dispatch<SetStateAction<boolean>>,
    setExpandedFilter:Dispatch<SetStateAction<FilterItem |null>>,
}
const HookFilter:React.FC<HookFilterProps> = React.memo(({setExpandedFilter,searchValue,filter,listFilter,addFilter,applyFilterGroup,lockedFilterValues,filterResultCounts,setShowCantFilter}) => {
    const listSearch =  (filter.liste ?? []);
    const [show,setShow] = useState(true)



    const orderedFilterList = useMemo(() => {
        const liste = filter.liste ?? [];
        if (filter.value !== "Type de restaurant") {
            return liste;
        }
        return [...liste].sort(
            (a, b) =>
                (filterResultCounts?.get(b) ?? 0) -
                (filterResultCounts?.get(a) ?? 0)
        );
    }, [filter.liste, filter.value, filterResultCounts]);
   
    const isTypeRestaurant = filter.value === "Type de restaurant";
    const isOrigineCuisine = filter.value === "Origine de la cuisine";

    const fold = (value: unknown) => {
        if (value == null) return "";
        const s = typeof value === "string" ? value : String(value);
        const lower = s.toLowerCase();
        return /[^\x00-\x7F]/.test(lower)
            ? lower
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/œ/g, "oe")
                .replace(/æ/g, "ae")
                .replace(/ß/g, "ss")
            : lower;
    };
    const listFolded = React.useMemo(
        () => listSearch.map(raw => ({ raw, norm: fold(raw) })),
        [listSearch]
    );
    const needle = React.useMemo(
        () => fold((searchValue || "").trim()),
        [searchValue]
    );
    const shown = React.useMemo(() => {
        if (!needle) return [];
        return listFolded
            .filter(it => it.norm.includes(needle))
            .map(it => it.raw);
    }, [needle, listFolded]);


    const currentPrice = useMemo(() => {
        return listFilter.find((filter): filter is [number, number] =>
                Array.isArray(filter) &&
                filter.length === 2 &&
                filter.every(
                    value =>
                        typeof value === "number"
                )
        );
    }, [listFilter]);

    const applyPrice = useCallback((min: number,max: number) => {
        const previousValues:FilterValue[] =currentPrice ? [currentPrice] : [];
        if (min === PRICE_MIN &&max === PRICE_MAX) {
            applyFilterGroup(previousValues,[] );
            return;
        }
        applyFilterGroup(
            previousValues,
            [[min, max]]
        );
    },[currentPrice,applyFilterGroup]);
    const MAX_VISIBLE_TYPE_FILTERS = 7;
    const visibleFilterList =  isTypeRestaurant ? orderedFilterList.slice(0, MAX_VISIBLE_TYPE_FILTERS) : orderedFilterList;
    const hasMoreTypeFilters = isTypeRestaurant && orderedFilterList.length > MAX_VISIBLE_TYPE_FILTERS;
    const {noteValue,noteLabel,notePercentage,noteVisualPercentage,noteLabelPercentage,showCheckNote,noteWrapperRef,handleNoteClick,handleNoteChange,handleNoteTouchStart,handleNoteTouchMove,handleNoteTouchEnd} = useNoteFilter({listFilter,applyNoteFilters: applyFilterGroup});
    const {minValue,maxValue,middle,showCheck,priceWrapperRef,handleMinChange,handleMaxChange,handlePriceClick,handlePriceTouchStart,handlePriceTouchMove,handlePriceTouchEnd} = usePriceSlider({initialMin: currentPrice?.[0] ?? PRICE_MIN,initialMax: currentPrice?.[1] ?? PRICE_MAX,onPriceChange: applyPrice});
    return <><div className={`elemFilter XsmallText ${searchValue ? ((shown.length>0) ? 'isSearch' : 'isNotSearch') : ''} ${!hasMoreTypeFilters && 'isClosed'}`}>
         { searchValue ? <>
                {
                    shown.map((elem, index) => {
                        const formattedLabel = formatFilterLabel(elem);
                        return <div key={'elemSearch'+index} onClick={() => addFilter(elem)} className={`elem ${listFilter.includes(elem) ? 'isSelect' : ''}`}>{isOrigineCuisine ? getCuisineDisplayLabel(formattedLabel) : formattedLabel }</div>
                    }) 
                }
            </>
            :
            <>
                <span className="smallTextBold" onClick={() => setShow(!show)}>{filter.value}  {show ? <FiChevronUp className="Chevron" size={14}  /> : <FiChevronDown className="Chevron" size={14} />} </span>
                {   filter.value === "Prix par personne" ? <>
                        {show && <div className='filterList filterPrice' >
                            <div className="containerPrice XsmallText" onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()} onTouchEnd={(e) => e.stopPropagation()}> 
                                <div className="value flexAllCenter" style={{marginLeft:`${minValue < 30 ? minValue+3 : minValue < 50 ? minValue+((50-minValue)/10) : minValue+((50-minValue)/10)+1}%`}}>{minValue+'€'}</div>
                                <div className="pointerValue" style={{marginLeft:`${minValue < 30 ? minValue+3 : minValue < 50 ? minValue+((50-minValue)/10) : minValue+((50-minValue)/10)+1}%`}}></div>
                                <div className="value flexAllCenter" style={{marginLeft:`${maxValue < 40 ?  maxValue + 2 : maxValue < 50 ?  maxValue + 1 : maxValue <= 90 ? maxValue : maxValue-2}%`}}>{maxValue === 100 ? '100€+' : maxValue+'€'}</div>
                                <div className="pointerValue" style={{marginLeft:`${maxValue < 40 ?  maxValue + 2 : maxValue < 50 ?  maxValue + 1 : maxValue <= 90 ? maxValue : maxValue-2}%`}}></div>                            


                                <div className="patchClose" onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()}></div>
                                <div className="range-wrapper" ref={priceWrapperRef}>
                                    <div className="price-touch-zone " style={{ left: 0, width: `${middle}%` }} onClick={(e) =>handlePriceClick(e, "min")} onTouchStart={handlePriceTouchStart} onTouchMove={(e) => handlePriceTouchMove(e, "min")} onTouchEnd={handlePriceTouchEnd} />
                                    <div className="price-touch-zone " style={{ left: `${middle}%`, width: `${100 - middle}%` }} onClick={(e) =>handlePriceClick(e, "max")}  onTouchStart={handlePriceTouchStart} onTouchMove={(e) => handlePriceTouchMove(e, "max")} onTouchEnd={handlePriceTouchEnd} />
                                    <input type="range" aria-label="Prix minimum en euros" id="minRange" min="0" max="100" step={PRICE_STEP} value={minValue} onChange={(e) => handleMinChange(e)}/>
                                    <input type="range" aria-label="Prix maximum en euros" id="maxRange" min="0" max="100" step={PRICE_STEP} value={maxValue} onChange={(e) => handleMaxChange(e)}/>
                                </div>
                                
                                <div className="slider-track" style={{left: `${Math.min(minValue, 88)}%`,width: `${Math.min(99, Math.max(11, maxValue - minValue))}%`}}></div>
                                {showCheck && <span className="checkAnimation"><FiCheck size={20} color="black" /></span>}
                                <div className="indicationSlide"><span>0 €</span><span>100 € +</span></div>
                            </div> 
                        </div>}
                    </>
                    :
                    filter.value === "Notes" ? <>
                        {show && <div className='filterList filterNote' >
                            <div className="containerPrice XsmallText" onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()} onTouchEnd={(e) => e.stopPropagation()}> 
                                <div className="value flexAllCenter" style={{marginLeft:`${Math.max(15,noteLabelPercentage)}%`}}>{noteLabel}</div>
                                <div className="pointerValue" style={{marginLeft:`${noteVisualPercentage}%`}}></div>                        

                                <div className="patchClose" onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()}></div>
                                <div className="range-wrapper" ref={noteWrapperRef}>
                                    <div className="price-touch-zone " style={{ left: 0, width: `100%` }} onClick={handleNoteClick} onTouchStart={handleNoteTouchStart} onTouchMove={handleNoteTouchMove} onTouchEnd={handleNoteTouchEnd} />
                                    <input type="range" aria-label="Note des restaurants" id="notes" min={NOTE_MIN} max={NOTE_MAX} step={NOTE_STEP} value={noteValue} onChange={handleNoteChange}/>
                                </div>
                                
                                <div className="slider-track sliderNote" style={{right: '-2px',width: `${100 - notePercentage}%`}}></div>
                                {showCheckNote && <span className="checkAnimation"><FiCheck size={20} color="black" /></span>}
                                <div className="indicationSlide indicationNote"><span>Toutes les notes</span><span>5 étoiles</span></div>
                            </div> 
                        </div>}
                    </> :
                    show && visibleFilterList &&  <div className={`filterList `} >
                        {visibleFilterList.map((elem,index) => {
                        const isLocked = typeof elem === "string" && lockedFilterValues.has(elem);
                        return <div key={'elemSearch'+index} onClick={() => {if(!isLocked){addFilter(elem)}else{setShowCantFilter(true)}}} className={`elem ${listFilter.includes(elem) ? 'isSelect' : ''} ${isLocked ? 'isLocked' : ''}`}>{isOrigineCuisine ? getCuisineDisplayLabel(formatFilterLabel(elem)) : formatFilterLabel(elem)}</div>
                    })}</div>
                }
                {hasMoreTypeFilters   && show && isTypeRestaurant && (
                    <p className="seeMoreType XsmallText" onClick={() => {setExpandedFilter(filter);setShowCantFilter(false)}}>
                        Tout afficher
                    </p>
                )}
            </>
         }
    </div>
    </>
})

export default HookFilter